import AppConfig from "../../../../AppConfig";
import ApiReqJson from "../ApiReqJson";


const urlBase= AppConfig.urlApiBase ;
const apiPrueba={
    Get: async ()=>{
        const url =  `${urlBase}/pruebaget`;
        return await ApiReqJson.requestGET(url);
    },
    GetConParams: async (param='testparam')=>{
        const url =  `${urlBase}/pruebaget_con_rparams/${param}`;
        return await ApiReqJson.requestGET(url);
    },
    Post: async ( dataObj={tipo:'test'})=>{
        const url =  `${urlBase}/pruebapost`;
        return await ApiReqJson.requestPOST(url,dataObj);
    },
    
};

export default apiPrueba;